import { ManageThreadsApi, useAPIAction } from "melco-shared-logic";
import { useCallback } from "react";

export const useAddThread = () => {
  let [addThreads] = useAPIAction(
    ManageThreadsApi,
    async (api) => {
      let data = await api.threadsCreateDraft({
        controlcenterMelcoModelsCreateThreadChart: {},
      });
      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "managethreads.actions.add",
    }
  );

  return useCallback(async () => {
    return await addThreads();
  }, [addThreads]);
};
